import { render } from "./master-data-form.vue?vue&type=template&id=529d2a12&scoped=true"
import script from "./master-data-form.vue?vue&type=script&lang=js"
export * from "./master-data-form.vue?vue&type=script&lang=js"

import "./master-data-form.vue?vue&type=style&index=0&id=529d2a12&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529d2a12"]])

export default __exports__